<template>
  <div
    class="tour-virtual-wrapper"
    :class="{ 'activo': isActive }"
    @click="activateTour"
    @mouseleave="deactivateTour" 
  >
    <iframe
      width="100%"
      height="600"
      :src="src"
      frameborder="0"
      allowfullscreen="true"
      style="border:0;"
      aria-label="Tour Virtual"
    ></iframe>
  </div>
</template>

<script lang="ts" setup>
import { defineProps, ref } from 'vue';

defineProps({
    src: {
        type: String,
        required: true
    }
});

const isActive = ref(false);

// Esta función activa el tour
function activateTour() {
  isActive.value = true;
}

// NUEVA FUNCIÓN: Esta desactiva el tour
function deactivateTour() {
  isActive.value = false;
}
</script>

<style scoped>
/*
  El CSS es exactamente el mismo de antes.
  La lógica de la cubierta '::before' sigue siendo perfecta.
*/
.tour-virtual-wrapper {
  position: relative;
  cursor: pointer;
}

/* La cubierta que bloquea el scroll por defecto */
.tour-virtual-wrapper::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 1;
}

/* Cuando está activo, la cubierta desaparece */
.tour-virtual-wrapper.activo::before {
  display: none;
}
</style>